import { ServiceService } from './service.service';
import { Injectable } from '@angular/core';
import { Observable, of, async } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Observable as MiObserver } from '../classes/observable';
import { AppComponent } from '../app.component';
import { Router } from '@angular/router';
import { HttpHandler } from '@angular/common/http';

export interface Ilogin {
  resultado?:boolean;
  token: any;
  log: any;
  valido_hasta: any;
  respuesta?:any;
}
interface IcheckToken {
  data: any;
  check: any;
  cuentas:any[];
}
interface IcheckTokenCD {
  data: any;
  item:any;
  check: any;
  cuentas:any[];
}

//@NgModule({providers: [forwardRef(() => LoginService)]})

//@Injectable({
//  providedIn: 'root'
//})
//@NgModule({providers: [libs_http]})
//const httpOptions = {
//  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
//};
const httpOption = {

  headers: { 'Content-Type': 'application/json' }

};
@Injectable()
export class LoginService extends ServiceService{

  URL = environment.get_url_login();

  public token;
  //public storage;
  //public URL = "http://192.168.0.163:358/";

  constructor(private router: Router,private httpHandler:HttpHandler){
    super(httpHandler);
  }

  login(usuario: any, clave: any, formodule?:any) {
    
    if(localStorage.getItem("token") && localStorage.getItem("token")!="false"){
      this.checkToken("api/checkToken", {token: localStorage.getItem("token")});
    }
    return new Promise((resolve, reject) => {
      var module = formodule!=null?{token:formodule,passbo:"6LO8r5qLIheTjYaUTEwLqOr4DAUCTve27jvDDYo2POPVnPUhuj9TWKMUZKwyHIrXzWR08FTCVkQFAEfqrHOqbweEKORyoWZe7yyHwb0k0xE60i45Y4k8vEeyoWjCUt76"}:null;
      
      var postParams = ({ usuario: usuario, clave: clave,formodule:formodule,module:module })
      
      this.post<Ilogin>('api/login', postParams,httpOption).subscribe(async (data) => {
        if (data.resultado == false && data.log != false) {
          reject(data.log);
        }
        if(localStorage.getItem("token")){
          localStorage.removeItem("token");
        }
        localStorage.setItem("token", data[0].token);
        localStorage.setItem("cuentas", JSON.stringify(data));
        localStorage.setItem("nombreEmpresa", data[0].titular);
        localStorage.setItem("inicialesEmpresa", data[0].iniciales);
        console.info(data[0]);
        this.token = data[0].token;
        return resolve(this.token);
      });


    });
  }
  loginshouldmodule(token_ext){
    return new Promise((resolve, reject) => {
      var module = {token:token_ext,passbo:"6LO8r5qLIheTjYaUTEwLqOr4DAUCTve27jvDDYo2POPVnPUhuj9TWKMUZKwyHIrXzWR08FTCVkQFAEfqrHOqbweEKORyoWZe7yyHwb0k0xE60i45Y4k8vEeyoWjCUt76"};
      this.post<Ilogin>('api/loginshouldmodule/'+module.passbo+"/"+module.token, null,httpOption).subscribe(async (data) => {
        if(data.respuesta==false){
          MiObserver.notify("logueando",false);
          return reject(data.log);
        }
        if (data.resultado == false && data.log != false) {
          MiObserver.notify("logueando",false);
          return reject(data.log);
        }
        if(localStorage.getItem("token")){
          localStorage.removeItem("token");
        }
        localStorage.setItem("token", data[0].token);
        localStorage.setItem("cuentas", JSON.stringify(data));
        localStorage.setItem("nombreEmpresa", data[0].titular);
        localStorage.setItem("inicialesEmpresa", data[0].iniciales);
        console.info(data);
        this.token = data[0].token;
        return resolve(this.token);
      });
    });

  }
  checkToken(url, json) {
    return new Promise(async (resolve,rejects)=>{
      if(!localStorage.getItem("token")){
        rejects(false);
      }
      await this.post<IcheckToken>(url, json, httpOption)
        .subscribe(async (data) => {
          if (data != undefined && (data.check == 1 || data.check == 'true' || data.check == true)) {
              if(data.cuentas.find((item)=>{
                localStorage.getItem("token")==item;
              })){
              localStorage.removeItem("cuentas");
              localStorage.removeItem("nombreEmpresa");
              localStorage.removeItem("inicialesEmpresa");
              this.router.navigate(['/ingreso']);
              return rejects(data);
            }
            localStorage.setItem("cuentas", JSON.stringify(data.cuentas));
            return  resolve(data);
          }
          else {
            let resp;
            await this.loginWithToken("api/loginwithtoken", json).then((data) => {
              return  resolve(data);
              
            }).catch((data) => {
              return  rejects(data);
            });
            if (await resp) {
              return resolve(resp);
            }
            return  rejects(false);
          }
        }) ;
    });
  }

  loginWithToken(url, json) {

    return new Promise((resolve,rejects)=>{
      if(!localStorage.getItem("token")){
        rejects(false);
      }



      this.post<Ilogin>(url, json, httpOption)
        .subscribe(async (data) => {
          if (data.resultado == false && data.log != false) {
            rejects(data.log);
          }
          if(localStorage.getItem("token")){
            localStorage.removeItem("token");
          }
          if(data==undefined || (!("token" in data))){
            MiObserver.notify("error_token","");
            return false;
          }
          localStorage.setItem("token", data.token);
          if(!data.token)
            rejects(false)
          this.token = data.token;
          return resolve(this.token);
        }) ;
    });
  }


  public handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error); // log to console instead
      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a HeroService message with the MessageService */
  private log(message: string) {
    console.log("mensaje: " + message);
  }
}
